// extracted by mini-css-extract-plugin
module.exports = {"option":"styles_option__LmrbW","optionDelete":"styles_optionDelete___g8HO","optionText":"styles_optionText__cUV0b"};